import * as React from 'react'
import { ModalWindow } from '$views/components/ModalWindow'
import { Text, Block } from '$views/components'
import { Button } from '$views/components/Button'
import { RoundedBlock } from '$views/components/RoundedBlock'
import { Division } from '$views/components/Division'
import { Icon } from '$views/components/Icon'
import { tagManager } from '$infrastructure/tagManager/tagManager'
import { proSubscriptionPlanOptions, ProSubscriptionPlan } from '$domain/model/pro/pro.model'

const logoFree = require('$icons/logoFreeFamiliados.svg')
const logo = require('$icons/logoFamiliados.svg')
const proIcon = require('$icons/pro.svg')
const rocketIcon = require('$icons/rocket.svg')

interface Props {
  onClosePopUp: () => void
  onClickButton: () => void
  isMonthlyLimit: boolean
}

export const LimitServicePopUp: React.SFC<Props> = ({ onClosePopUp, onClickButton, isMonthlyLimit }) => {
  const onClickWantPro = () => {
    tagManager.push({ event: 'fam', fam_id: 'PopUpProOffersLimited' })
    onClickButton()
  }

  const getTitle = () => {
    if (isMonthlyLimit) {
      return 'Has alcanzado el límite de 100 ofertas al mes...'
    }

    return 'Has alcanzado el límite de 10 ofertas al día...'
  }

  return (
    <ModalWindow onClose={onClosePopUp}>
      <Text title as="span">
        {getTitle()}
      </Text>
      <Text marginTop="base" marginBottom="small">
        Hazte PRO y accede a todas, sin límite.
      </Text>
      <RoundedBlock shadow>
        <Block flex justify="between">
          <Block marginBottom="mini" flex alignItems="center">
            <Icon content={logo} logo />
            <Icon content={proIcon} resize={{ height: 20, width: 35 }} />
          </Block>
          <Block textAlign="right">
            <Text weight="medium">Ofertas ilimitadas</Text>
            <Text tiny>{`Desde ${Intl.NumberFormat('es-es', {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            }).format(
              Math.floor(proSubscriptionPlanOptions.price[ProSubscriptionPlan.yearly] / 12) / 100,
            )} €/mes`}</Text>
          </Block>
        </Block>
        <Division marginTop="mini" marginBottom="mini" />
        <Block flex justify="between">
          <Icon content={logoFree} resize={{ width: 120, height: 20 }} marginBottom="mini" />
          <Block textAlign="right">
            <Text weight="medium">10 ofertas/día</Text>
            <Text tiny>GRATIS</Text>
            <Text tiny color="menu">
              Máximo 100 ofertas al mes
            </Text>
          </Block>
        </Block>
      </RoundedBlock>
      <Block marginTop="small" flex>
        <Block>
          <Text color="yellow" weight="bold">
            NUEVO!
          </Text>
          <Block flex justify="end">
            <Icon content={rocketIcon} size="ml" marginTop="tiny" marginRight="none" />
          </Block>
        </Block>
        <Division vertical color="yellow" full />
        <Block>
          <Text menu weight="medium">
            Mensajes de presentación
          </Text>
          <Text menu>Multiplica x4 las oportunidades de que te contacten!</Text>
        </Block>
      </Block>
      <Block marginTop="medium">
        <Button primary onClick={onClickWantPro}>
          Quiero hacerme PRO
        </Button>
      </Block>
      <Block marginTop="base" marginBottom="medium">
        <Button primary bordered onClick={onClosePopUp}>
          Quizá más adelante
        </Button>
      </Block>
    </ModalWindow>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/ProPopUp/LimitServicePopUp.tsx